import { StringType } from '../App/types';

export const maskNumbers = (value: StringType | undefined, maskChar = '●'): StringType | undefined => {
  if (!value) {
    return value;
  }
  return value.replace(/\d/g, maskChar);
};
